import { render, staticRenderFns } from "./course_schoolorder_management.vue?vue&type=template&id=5589e422&scoped=true&"
import script from "./course_schoolorder_management.vue?vue&type=script&lang=js&"
export * from "./course_schoolorder_management.vue?vue&type=script&lang=js&"
import style0 from "./course_schoolorder_management.vue?vue&type=style&index=0&id=5589e422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589e422",
  null
  
)

export default component.exports